type Props = {
  text: string
  onClick?: () => void
};

function HeaderTenantTitle({text, onClick}: Props) {
  return <h1 className={
    `duration-1000 ease-in-out text-2xl md:text-4xl font-extralight text-left text-slate-700/[.85] font-thin tracking-tighter ${onClick ? 'cursor-pointer' : ''}`
  } onClick={onClick}>{text}</h1>;
};

export default HeaderTenantTitle;